<template>
  <!-- HTML 정의하는 부분 -->
  <!-- 1차 퍼블리셔가 작업 영역 -->
  <!-- 2차 개발자가 Template 화 작업 진행-->
  <v-container fluid>
    <page-header title="사이트별 가동 현황" :use-list="[]"></page-header>
    <v-row class="site_top_area">
      <v-col class="d-flex align-center click_area" cols="1">
        <v-btn small class="font-weight-bold mr-2" v-if="admin" @click="popup=true">사이트 검색</v-btn>
        <v-btn small class="font-weight-bold mr-2" v-if="cctvView" @click="viewPopup=true">CCTV</v-btn>
      </v-col>
      <v-col cols="4" class="d-flex justify-space-around align-center py-1">
        <span class="white--text font-weight-bold">{{siteInfo.AREA}}</span>
        <v-chip
          class="white--text"
          :color="weatherRes.SKYNAME === '맑음'? 'blue lighten-1' : 'blue-grey' "
          small
        >
          <span v-if="weatherRes.PTY === '0'">{{weatherRes.SKYNAME}}</span>
          <span v-else>{{weatherRes.SKYNAME}}, {{weatherRes.PTYNAME}}</span>
        </v-chip>
        <span class="degree">{{weatherRes.T1H}}℃</span>
        <span>
          <img src="@/assets/image/pc/rain.png" alt>
        </span>
        <span v-if="weatherRes.PTY === '0'" class="weather_txt">{{ weatherRes.RN1 }}</span>
        <span v-else class="weather_txt">{{ weatherRes.RN1 }}</span>
        <span>
          <img src="@/assets/image/pc/humidity.png" alt>
        </span>
        <span class="weather_txt humidity">{{ weatherRes.REH }}%</span>
        <span>
          <img src="@/assets/image/pc/cloud.png" alt>
        </span>
        <span class="weather_txt cloud">{{ weatherRes.WSD }}m/s</span>
      </v-col>
      <v-col cols="3" class="d-flex align-center justify-end py-1">
        <v-btn link small class="font-weight-bold" to="/monitoring">
          <img src="@/assets/image/pc/factory_mark.png" alt class="pr-2"> 내 발전소 모두보기
        </v-btn>
      </v-col>
      <v-col class="d-flex align-center justify-end py-1">
        <span class="txt" v-if="siteInfo.USER_PH">연락처 {{siteInfo.USER_PH}}</span>
        <span v-if="admin">
          <v-btn class="name" text v-on:click="goRegister(siteInfo.SITE_ID)">{{ siteInfo.SITE_NM }}</v-btn>
        </span>
        <span class="name" v-else>{{ siteInfo.SITE_NM }}</span>
      </v-col>
    </v-row>
    <v-dialog v-model="popup" persistent max-width="450px" scrollable>
      <detail-status-popup @closeDetailPop="popup=false" status="search"></detail-status-popup>
    </v-dialog>
    <v-dialog v-model="popup2" persistent max-width="450px" scrollable>
      <v-card>
        <v-card-title>
          지역별
          <v-btn icon dark @click="popup2 = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-tabs>
            <v-tab></v-tab>
          </v-tabs>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-if="viewPopup" v-model="viewPopup" persistent max-width="600px">
      <cctv-popup
        @closeDetailPop="viewPopup=false"
        :cctv-cnt="siteInfo.CCTV_CNT"
        :site-id="siteInfo.SITE_ID"
      ></cctv-popup>
    </v-dialog>
  </v-container>
</template>

<script>
// 스크립트를 정의하는 부분
// 개발자 작업 영역
import PageHeader from '@/layout/components/PageHeader'
import { weatherGet } from '@/api/weather'
import DetailStatusPopup from '@/components/monitoring/DetailStatusPopup'
import { getSearchSite } from '@/api/monitoring/monitoring'
import Message from '@/utils/message'
import localStore from '@/utils/localStore'
import CctvPopup from '@/views/pc/site/CctvPopup'

export default {
  name: 'SiteWorkTopBar',
  components: {
    PageHeader,
    DetailStatusPopup,
    CctvPopup
  },
  props: {
    type: {
      type: String
    },
    siteInfo: {
      type: Object
    }
  },
  data() {
    return {
      viewPopup: false,
      popup: false,
      popup2: false,
      paramList: [],
      admin: false,
      weatherRes: {
        PTY: 1,
        REH: 50,
        WSD: 0.5,
        SKYNAME: '  ',
        T1H: '21'
      },
      siteTabList: [
        {
          title: '경기도',
          code: 0
        }
      ]
    }
  },
  created() {
    // DOM이 만들어 지기 전 실행 되는 곳
    // Data를 사전에 준비할 경우 사용된다.
    this.admin = localStore.get('admin') === 'true'
  },
  mounted() {
    // DOM에 해당 .vue가 들어가게 되면 실행 되는 곳
    // onload 상태와 동일하다. DOM 이후에 조작할 경우 이곳에서 수행
  },
  watch: {
    siteInfo() {
      this.getWeather()
    }
  },
  computed: {
    // 값이 자주 변경됨에 따라, 관련되어 데이터 혹은 view가 바뀌어야 할 경우 사용
    // method를 바로 연결하면 tic 단위로 계속 실행되기 때문에, 값이 변경할 때만 수행되고,
    // cache로 남는 computed를 활용하는 것이 성능에 좋음
    searchArea() {
      return localStore.get('admin') === 'true'
    },
    cctvView() {
      return this.siteInfo.CCTV_STAT !== null && this.siteInfo.CCTV_STAT !== 'N'
    }
  },
  methods: {
    // .vue 내부에서 사용되는 함수를 정의한다.
    // 이벤트에 따라 실행하거나, 내부적으로 사용되는 함수들을 정의한다.
    goRegister(SITE_ID) {
      if (this.type === 'ESS') {
        this.$router.push({
          path: '/master/siteEssReg',
          query: { site_id: SITE_ID }
        })
      } else {
        this.$router.push({
          path: '/master/siteRegister',
          query: { site_id: SITE_ID }
        })
      }
    },
    emitSearchSite(siteName) {
      this.searchText = siteName
      this.searchSite()
    },
    searchSite() {
      if (this.searchText !== '') {
        getSearchSite(this.searchText, '').then(res => {
          this.paramList = res
          if (res.length === 0) {
            Message.warn('검색 결과가 없습니다.')
          }
        })
      } else {
        // Message.warn('검색어 입력!!')
      }
    },
    getWeather() {
      // 3. 조회한 사이트주소로 날씨 조회
      let param = 'lat=' + this.siteInfo.LAT + '&lon=' + this.siteInfo.LON
      weatherGet('/weather/forecastTimeData?' + param).then(weatherResponse => {
        this.weatherRes = weatherResponse
      })
    }
  }
}
</script>

<style scoped>
.weather_txt {
  display: inline-block;
  color: #fff;
  text-align: center;
}

.name {
  font-size: 20px;
  color: #fff;
  font-weight: bold;
}

.txt {
  color: #8c98ac;
  font-size: 14px;
  font-weight: bold;
}

.degree {
  color: #1982ff;
  font-size: 26px;
}

.radius {
  display: inline-block;
  border-radius: 15px;
  background: #788494;
  color: #fff;
  font-size: 14px;
}
.site_top_area {
  position: relative;
  background: #565656;
}
</style>
